import { FunctionComponent, useContext, useState, useRef } from 'react';
import classNames from 'classnames';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import useOnclickOutside from 'react-cool-onclickoutside';
import LayoutContext from 'Context/LayoutContext';
import SocialButtons from '@media-ui/core/src/components/SocialButtons';
import ShareLogo from './logo/ShareLogo.svg';
import * as s from './QuizHeader.css';
import * as T from './QuizHeader.types';
type SocialId = 'ok' | 'vk';
export const QuizHeader: FunctionComponent<T.IQuizHeaderProps> = ({ progressBarStart = 0, progressBarEnd = 0, quizType, }) => {
    const getBtn = (socialId: SocialId) => ({
        socialId,
        onClick() {
            const eventName = quizType === 'social' ? 'petQuizShare' : 'marketQuizShare';
            snitchCounter(eventName, {
                targetNetowrk: socialId,
            });
        },
    });
    const socialButtonsProps = {
        adaptive: true,
        buttons: [getBtn('ok'), getBtn('vk')],
        iconOnly: false,
        wide: true,
    };
    const tooltipRef = useRef(null);
    const { isMobile } = useContext(LayoutContext);
    const headerClass = classNames(s.header, {
        [s['touch-header']]: isMobile,
    });
    // Скрытие/показ тултипа
    const [shown, setTooltip] = useState(false);
    /**
     * Переключение видимости тултипа с соц.кнопками
     */
    const toggleShareTooltip = () => {
        setTooltip(!shown);
    };
    /**
     * Закрытие тултипа по клику вне его области
     * true - игнорирует клик по кнопке, вызвавшей тултип
     */
    useOnclickOutside(() => setTooltip(false), {
        refs: [tooltipRef],
    });
    /**
     * Прогресс-бар для шагов в тесте
     */
    const renderProgressBar = () => {
        if (!progressBarStart && !progressBarEnd) {
            return null;
        }
        if (progressBarStart + 1 > progressBarEnd) {
            return null;
        }
        const progressLineStyle = {
            width: `${(progressBarStart + 1) * (100 / progressBarEnd)}%`,
        };
        return (<div className={s.header__line}>
        <span className={s['progress-line']} style={progressLineStyle}></span>
      </div>);
    };
    const buttonClass = classNames(s.header__button, {
        [s.active]: shown,
    }, 'ignore-outsideclick-class');
    const tooltipClass = classNames(s.dropdown__menu, {
        [s.visible]: shown,
    });
    return (<div className={headerClass}>
      <div className={s.header__dropdown}>
        <button className={buttonClass} onClick={toggleShareTooltip}>
          <ShareLogo className={s.buttonLogo}/>
        </button>
        <div className={tooltipClass} ref={tooltipRef}>
          <h6 className={s['share-title']}>Поделиться с друзьями</h6>
          <SocialButtons className={s['share-buttons']} {...socialButtonsProps} isMobile={isMobile}/>
        </div>
      </div>
      {renderProgressBar()}
    </div>);
};
export default QuizHeader;
